"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _booking_return = require("@/api/goods_activity/booking_return");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BookingReturnTable',
  data: function data() {
    return {
      searchForm: {
        keyword: '',
        applyTimeRange: []
      },
      activeTab: 'all',
      tableData: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      this.loading = true;

      // 根据标签页设置状态筛选
      var returnStatus = null;
      switch (this.activeTab) {
        case 'pending':
          returnStatus = 0; // 未受理
          break;
        case 'approved':
          returnStatus = 4; // 同意申请退款
          break;
        case 'rejected':
          returnStatus = 5; // 拒绝申请退款
          break;
        case 'completed':
          returnStatus = 9; // 已完成
          break;
        default:
          returnStatus = null;
      }
      var params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        keyword: this.searchForm.keyword,
        startTime: this.searchForm.applyTimeRange && this.searchForm.applyTimeRange.length > 0 ? this.searchForm.applyTimeRange[0] : '',
        endTime: this.searchForm.applyTimeRange && this.searchForm.applyTimeRange.length > 0 ? this.searchForm.applyTimeRange[1] : '',
        returnStatus: returnStatus
      };
      (0, _booking_return.bookingReturnPage)(params).then(function (response) {
        // 处理返回的数据，转换字段名以匹配表格列
        _this.tableData = response.records.map(function (item) {
          // 确保 returnStatus 是数字类型
          var returnStatus = parseInt(item.returnStatus);
          return _objectSpread(_objectSpread({}, item), {}, {
            returnId: item.returnId,
            mobile: item.mobile,
            storeName: item.storeName || '--',
            paymentMethod: _this.getPayTypeText(item.paymentMethod),
            // 默认支付方式，可能需要从订单中获取
            orderAmount: item.orderAmount,
            returnMoney: item.returnMoney ? parseFloat(item.returnMoney).toFixed(2) : '0.00',
            goodsList: item.goodsList || [],
            addTime: item.addTime,
            returnStatus: returnStatus,
            returnStatusText: _this.getReturnStatusText(returnStatus),
            returnTypeText: _this.getReturnTypeText(item.returnType)
          });
        });
        _this.pagination.total = response.total || 0;
      }).catch(function (error) {
        console.error('获取退货订单数据失败:', error);
        _this.$message.error('获取退货订单数据失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    getReturnStatusText: function getReturnStatusText(status) {
      var statusMap = {
        0: '未受理',
        1: '受理中',
        2: '受理完成',
        3: '商家已收货',
        4: '同意申请退款',
        5: '拒绝申请退款',
        6: '已退款',
        9: '已完成'
      };
      return statusMap[status] || '未知状态';
    },
    getReturnStatusTagType: function getReturnStatusTagType(status) {
      var typeMap = {
        0: 'info',
        // 未受理 - 灰色
        1: 'warning',
        // 受理中 - 橙色
        2: 'primary',
        // 受理完成 - 蓝色
        3: 'primary',
        // 商家已收货 - 蓝色
        4: 'success',
        // 同意申请退款 - 绿色
        5: 'danger',
        // 拒绝申请退款 - 红色
        6: 'success',
        // 已退款 - 绿色
        9: 'info' // 已完成 - 灰色
      };
      return typeMap[status] || 'info';
    },
    getReturnTypeText: function getReturnTypeText(type) {
      var typeMap = {
        1: '全额退款',
        2: '部分退款'
      };
      return typeMap[type] || '未知类型';
    },
    getPayTypeText: function getPayTypeText(type) {
      var typeMap = {
        1: '微信',
        2: '支付宝'
      };
      return typeMap[type] || '未知类型';
    },
    // 模拟获取订单手机号，实际应该通过API获取
    getMobileFromOrder: function getMobileFromOrder(orderId) {
      // 这里应该通过API获取订单信息
      return '待获取';
    },
    // 模拟获取订单金额，实际应该通过API获取
    getOrderAmount: function getOrderAmount(orderId) {
      // 这里应该通过API获取订单信息
      return '待获取';
    },
    // 模拟获取订单商品列表，实际应该通过API获取
    getListGoods: function getListGoods(orderId) {
      // 这里应该通过API获取订单信息
      return '待获取';
    },
    handleSearch: function handleSearch() {
      // 搜索逻辑
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleView: function () {
      var _handleView = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 触发父组件事件，显示退款详情标签页
              this.$emit('toDetail', row.returnId);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleView(_x) {
        return _handleView.apply(this, arguments);
      }
      return handleView;
    }(),
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchData();
    },
    formatDate: function formatDate(value) {
      if (!value) return '';
      // 如果是时间戳格式
      if (typeof value === 'number') {
        var date = new Date(value);
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }
      // 如果是字符串格式
      if (typeof value === 'string') {
        var _date = new Date(value);
        if (isNaN(_date.getTime())) return value; // 无效日期返回原值
        var _year = _date.getFullYear();
        var _month = String(_date.getMonth() + 1).padStart(2, '0');
        var _day = String(_date.getDate()).padStart(2, '0');
        var _hours = String(_date.getHours()).padStart(2, '0');
        var _minutes = String(_date.getMinutes()).padStart(2, '0');
        var _seconds = String(_date.getSeconds()).padStart(2, '0');
        return "".concat(_year, "-").concat(_month, "-").concat(_day, " ").concat(_hours, ":").concat(_minutes, ":").concat(_seconds);
      }
      return value;
    }
  },
  watch: {
    activeTab: function activeTab() {
      this.pagination.currentPage = 1;
      this.fetchData();
    }
  }
};